import * as ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthContextProvider } from './context/authContext';
import config from './config';
import './style.scss';
import { BrowserRouter } from 'react-router-dom';
import { MetaModelUserProvider } from './context/metamodelUserContext';
import { Provider } from 'react-redux';
import store from './redux/store';
import AppInitializer from './app/appInitializer';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <>
    <GoogleOAuthProvider clientId={config.googleClientId}>
      <AuthContextProvider>
        <Provider store={store}>
          <BrowserRouter>
            <MetaModelUserProvider>
              <AppInitializer />
            </MetaModelUserProvider>
          </BrowserRouter>
        </Provider>
      </AuthContextProvider>
    </GoogleOAuthProvider>
  </>
);
